// import styles from "./Styles/Root.module.scss";
// import { Link, Outlet, useNavigate, useLocation } from "react-router-dom";
// import { useContext, useState, useEffect, useRef } from "react";
// import { MainContext } from "../App";
// import logo from "./assets/logo1.png";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faMagnifyingGlass,
//   faUser,
//   faAddressCard,
//   faCalculator,
//   faBars,
//   faXmark,
//   faCrown,
// } from "@fortawesome/free-solid-svg-icons";
// import UseScrollToTop from "./Hooks/useScrollsToTheTop";
// import Filter from "./Finding/Filter";
// import Footer from "./Footer";
// import userStateManager, { User } from "./AppWriteOAuth/UserStateManager";
// import CookiesBanner from "./CookiesBanner/CookiesBanner";
// import PromotionalBanner from "./VIP/PromotionalBanner";

// function Root() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   UseScrollToTop();
//   const context = useContext(MainContext);

//   // მიმდინარე მომხმარებლის მდგომარეობა
//   const [user, setUser] = useState<User | null>(
//     userStateManager.getCurrentUser()
//   );

//   const {
//     menuBar,
//     setMenuBar,
//     selectedNavigation,
//     setSelectedNavigation,
//     setSearchByCity,
//     setSearchByDistrict,
//     setSearchByProfession,
//     setSearchByVerification,
//     setSearchByExperience,
//     setSearchByPriceFrom,
//     setSearchByPriceUpTo,
//     setTitleForCategory,
//     scrolled,
//     setScrolled,
//   } = context;

//   // კომპონენტის მაუნთის სტატუსის თრეკინგი
//   const isMounted = useRef(true);

//   useEffect(() => {
//     // კომპონენტი მაუნთირებულია
//     isMounted.current = true;

//     const initializeAuth = async () => {
//       // ვიღებთ მიმდინარე მომხმარებელს სტეიტ მენეჯერიდან
//       const currentUser = userStateManager.getCurrentUser();

//       if (currentUser) {
//         setUser(currentUser);

//         // თუ google-ის მომხმარებელი არ არის, ვიწყებთ ტოკენის შემოწმებას
//         if (currentUser.user_type !== "clientOfGoogle") {
//           // დავიწყოთ პერიოდული შემოწმება UserStateManager-ის მეშვეობით
//           userStateManager.startTokenValidationCheck();
//         } else {
//           // Google მომხმარებლისთვის შევამოწმოთ AppWrite-ის სესია
//           try {
//             const { getCurrentUser: getAppWriteUser } = await import(
//               "./AppWriteOAuth/AppWrite"
//             );
//             const appWriteUser = await getAppWriteUser();
//             if (!appWriteUser) {
//               // თუ AppWrite-ის სესია აღარ არსებობს, გავასუფთაოთ ლოკალური მონაცემები
//               userStateManager.clearUser();
//             }
//           } catch (error) {
//             console.error("AppWrite session check failed:", error);
//           }
//         }
//       } else {
//         // თუ localStorage-ში არ არის მომხმარებელი, ვამოწმებთ cookies-ებს
//         const isAuthenticated = await userStateManager.checkAuthStatus();

//         // თუ cookies-ში ნაპოვნია ვალიდური ტოკენი, მომხმარებელი უკვე განახლდა შემოწმების პროცესში
//         if (isAuthenticated) {
//           setUser(userStateManager.getCurrentUser());
//         }
//       }
//     };

//     // ინიციალიზაცია
//     initializeAuth();

//     // ვუსმენთ UserStateManager-ის ცვლილებებს
//     const userChangeListener = (updatedUser: User | null) => {
//       if (isMounted.current) {
//         setUser(updatedUser);
//       }
//     };

//     userStateManager.addListener(userChangeListener);

//     // სქროლის მსმენელის დამატება
//     const handleScroll = () => {
//       const scrollPosition = window.scrollY;
//       if (scrollPosition > 50) {
//         setScrolled(true);
//       } else {
//         setScrolled(false);
//       }
//     };

//     window.addEventListener("scroll", handleScroll);

//     // Cleanup ფუნქცია
//     return () => {
//       // ვნიშნავთ რომ კომპონენტი unmount მოხდა
//       isMounted.current = false;

//       // ვხსნით მომხმარებლის ცვლილების მსმენელს
//       userStateManager.removeListener(userChangeListener);

//       // ვხსნით სქროლის მსმენელს
//       window.removeEventListener("scroll", handleScroll);

//       // ვაჩერებთ ტოკენის შემოწმების ინტერვალს
//       userStateManager.stopTokenValidationCheck();
//     };
//   }, []);

//   // ეფექტი, რომელიც იმუშავებს ყოველი ნავიგაციისას
//   useEffect(() => {
//     const checkAuth = async () => {
//       const currentUser = userStateManager.getCurrentUser();

//       // მხოლოდ იმ შემთხვევაში შევამოწმოთ, თუ მომხმარებელი უკვე შესულია
//       // მხოლოდ JWT მომხმარებლებისთვის ვამოწმებთ ავთენტიფიკაციას
//       if (currentUser && currentUser.user_type !== "clientOfGoogle") {
//         await userStateManager.checkAuthStatus();
//       }
//     };

//     checkAuth();
//   }, [location.pathname]); // დამოკიდებულება location.pathname-ზე

//   // ვაყენებთ არჩეულ ნავიგაციას URL-ის მიხედვით
//   useEffect(() => {
//     const path = location.pathname;
//     if (path === "/") {
//       setSelectedNavigation("home");
//     } else if (path.includes("calculator")) {
//       setSelectedNavigation("calculator");
//     } else if (path.includes("search")) {
//       setSelectedNavigation("search");
//     } else if (path.includes("registration")) {
//       setSelectedNavigation("registration");
//     } else if (path.includes("authorization")) {
//       setSelectedNavigation("authorization");
//     }
//   }, [location]);

//   const handleNavigation = (nav: string) => {
//     window.scrollTo({
//       top: 0,
//       behavior: "smooth",
//     });
//     setSelectedNavigation(nav);
//     setMenuBar(false);
//     setSearchByCity("");
//     setSearchByDistrict("");
//     setSearchByProfession("");
//     setSearchByVerification("");
//     setSearchByExperience("");
//     setSearchByPriceFrom("");
//     setSearchByPriceUpTo("");
//     setTitleForCategory("");
//   };

//   const handleLogin = async () => {
//     if (user?.user_type === "client") {
//       navigate(`/client/personal-page/${user.external_Id}`);
//     } else if (user?.user_type === "clientOfGoogle") {
//       navigate(`/google-account`);
//     } else {
//       navigate(`/craftsman/personal-page/${user?.external_Id}`);
//     }
//     setMenuBar(false);
//   };

//   // მენიუს გადართვა ანიმაციით
//   const toggleMenu = () => {
//     setTimeout(() => {
//       setMenuBar(!menuBar);
//     }, 50);
//   };

//   // მენიუს ელემენტის კომპონენტი
//   const MenuLink = ({
//     to,
//     iconComponent,
//     text,
//     isSelected,
//     onClick,
//   }: {
//     to: string;
//     iconComponent: React.ReactNode;
//     text: string;
//     isSelected: boolean;
//     onClick: () => void;
//   }) => (
//     <Link
//       to={to}
//       className={`${styles.navElement} ${
//         isSelected ? styles.selectedNavElement : ""
//       }`}
//       onClick={onClick}
//     >
//       {iconComponent}
//       <span>{text}</span>
//     </Link>
//   );

//   return (
//     <>
//       <div className={styles.parentContainer}>
//         <div
//           className={`${styles.navContainer} ${
//             scrolled ? styles.scrolled : ""
//           }`}
//         >
//           <nav className={styles.nav}>
//             <div className={styles.logoContainer}>
//               <Link
//                 to="/"
//                 onClick={() => {
//                   handleNavigation("home");
//                 }}
//               >
//                 <img src={logo} alt="logo" className={styles.logoImg} />
//               </Link>

//               <div className={styles.logoContainer__menuBarIcon}>
//                 {!menuBar ? (
//                   <div>
//                     <FontAwesomeIcon
//                       icon={faBars}
//                       className={styles.faBars}
//                       onClick={toggleMenu}
//                       aria-label="მენიუს გახსნა"
//                       aria-expanded="false"
//                     />
//                   </div>
//                 ) : (
//                   <FontAwesomeIcon
//                     icon={faXmark}
//                     className={styles.faXmark}
//                     onClick={toggleMenu}
//                     aria-label="მენიუს დახურვა"
//                     aria-expanded="true"
//                   />
//                 )}
//               </div>
//             </div>

//             <div
//               className={
//                 menuBar ? styles.mobileNavigation : styles.desktopNavigation
//               }
//               aria-expanded={menuBar}
//               role="navigation"
//             >
//               <MenuLink
//                 to="/vipmanager"
//                 iconComponent={
//                   <FontAwesomeIcon icon={faCrown} className={styles.faCrown} />
//                 }
//                 text="VIP პაკეტები"
//                 isSelected={selectedNavigation === "vipmanager"}
//                 onClick={() => handleNavigation("vipmanager")}
//               />

//               {/* გამოვიყენოთ ცალკე კომპონენტი მენიუს ელემენტებისთვის */}
//               <MenuLink
//                 to="/calculator"
//                 iconComponent={
//                   <FontAwesomeIcon
//                     icon={faCalculator}
//                     className={styles.faCalculator}
//                   />
//                 }
//                 text="კალკულატორი"
//                 isSelected={selectedNavigation === "calculator"}
//                 onClick={() => handleNavigation("calculator")}
//               />

//               <MenuLink
//                 to="/search"
//                 iconComponent={
//                   <FontAwesomeIcon
//                     icon={faMagnifyingGlass}
//                     className={styles.faMagnifyingGlass}
//                   />
//                 }
//                 text="დეტალური ძებნა"
//                 isSelected={selectedNavigation === "search"}
//                 onClick={() => handleNavigation("search")}
//               />

//               <MenuLink
//                 to="/registration"
//                 iconComponent={
//                   <FontAwesomeIcon
//                     icon={faAddressCard}
//                     className={styles.faAddressCard}
//                   />
//                 }
//                 text="რეგისტრაცია"
//                 isSelected={selectedNavigation === "registration"}
//                 onClick={() => handleNavigation("registration")}
//               />

//               {user ? (
//                 <div className={styles.isAuthorized} onClick={handleLogin}>
//                   <img
//                     src={user.profile_img}
//                     alt={user.first_name}
//                     className={styles.isAuthorized__userImg}
//                   />
//                   <p>{user.first_name}</p>
//                 </div>
//               ) : (
//                 <MenuLink
//                   to="/authorization"
//                   iconComponent={
//                     <FontAwesomeIcon icon={faUser} className={styles.faUser} />
//                   }
//                   text="შესვლა"
//                   isSelected={selectedNavigation === "authorization"}
//                   onClick={() => handleNavigation("authorization")}
//                 />
//               )}
//             </div>
//           </nav>
//         </div>

//         <Filter />
//         <CookiesBanner />
//         <PromotionalBanner />
//         <div className={styles.outlet}>
//           <div className={styles.outletInCenter}>
//             <Outlet />
//           </div>
//         </div>
//       </div>
//       <Footer />
//     </>
//   );
// }

// export default Root;










////////////////////////
import styles from "./Styles/Root.module.scss";
import { Link, Outlet, useNavigate, useLocation } from "react-router-dom";
import { useContext, useState, useEffect, useRef } from "react";
import { MainContext } from "../App";
import logo from "./assets/logo1.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMagnifyingGlass,
  faUser,
  faAddressCard,
  faCalculator,
  faBars,
  faXmark,
  faCrown,
} from "@fortawesome/free-solid-svg-icons";
import UseScrollToTop from "./Hooks/useScrollsToTheTop";
import Filter from "./Finding/Filter";
import Footer from "./Footer";
import userStateManager, { User } from "./AppWriteOAuth/UserStateManager";
import CookiesBanner from "./CookiesBanner/CookiesBanner";
import PromotionalBanner from "./VIP/PromotionalBanner";

function Root() {
  const navigate = useNavigate();
  const location = useLocation();
  UseScrollToTop();
  const context = useContext(MainContext);

  // მიმდინარე მომხმარებლის მდგომარეობა
  const [user, setUser] = useState<User | null>(
    userStateManager.getCurrentUser()
  );

  // თუ რაიმე მიზეზით localstorage-ში user-ის მნიშვნელობები გახდა null, მაშინ შესვლის ღილაკში შევამოწმოთ
  const isUserValid = (user: User | null): boolean => {
    return (
      user !== null &&
      user.external_Id !== null &&
      user.external_Id !== "" &&
      user.external_Id !== "null" &&
      user.first_name !== null &&
      user.first_name !== "" &&
      user.first_name !== "null" &&
      user.user_type !== "unknown"
    );
  };


  const {
    menuBar,
    setMenuBar,
    selectedNavigation,
    setSelectedNavigation,
    setSearchByCity,
    setSearchByDistrict,
    setSearchByProfession,
    setSearchByVerification,
    setSearchByExperience,
    setSearchByPriceFrom,
    setSearchByPriceUpTo,
    setTitleForCategory,
    scrolled,
    setScrolled,
  } = context;

  // კომპონენტის მაუნთის სტატუსის თრეკინგი
  const isMounted = useRef(true);

  useEffect(() => {
    // კომპონენტი მაუნთირებულია
    isMounted.current = true;

    const initializeAuth = async () => {
      // ვიღებთ მიმდინარე მომხმარებელს სტეიტ მენეჯერიდან
      const currentUser = userStateManager.getCurrentUser();

      if (currentUser) {
        setUser(currentUser);

        // თუ google-ის მომხმარებელი არ არის, ვიწყებთ ტოკენის შემოწმებას
        if (currentUser.user_type !== "clientOfGoogle") {
          // დავიწყოთ პერიოდული შემოწმება UserStateManager-ის მეშვეობით
          userStateManager.startTokenValidationCheck();
        } else {
          // Google მომხმარებლისთვის შევამოწმოთ AppWrite-ის სესია
          try {
            const { getCurrentUser: getAppWriteUser } = await import(
              "./AppWriteOAuth/AppWrite"
            );
            const appWriteUser = await getAppWriteUser();
            if (!appWriteUser) {
              // თუ AppWrite-ის სესია აღარ არსებობს, გავასუფთაოთ ლოკალური მონაცემები
              userStateManager.clearUser();
            }
          } catch (error) {
            console.error("AppWrite session check failed:", error);
          }
        }
      } else {
        // თუ localStorage-ში არ არის მომხმარებელი, ვამოწმებთ cookies-ებს
        const isAuthenticated = await userStateManager.checkAuthStatus();

        // თუ cookies-ში ნაპოვნია ვალიდური ტოკენი, მომხმარებელი უკვე განახლდა შემოწმების პროცესში
        if (isAuthenticated) {
          setUser(userStateManager.getCurrentUser());
        }
      }
    };

    // ინიციალიზაცია
    initializeAuth();

    // ვუსმენთ UserStateManager-ის ცვლილებებს
    const userChangeListener = (updatedUser: User | null) => {
      if (isMounted.current) {
        setUser(updatedUser);
      }
    };

    userStateManager.addListener(userChangeListener);

    // სქროლის მსმენელის დამატება
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      if (scrollPosition > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup ფუნქცია
    return () => {
      // ვნიშნავთ რომ კომპონენტი unmount მოხდა
      isMounted.current = false;

      // ვხსნით მომხმარებლის ცვლილების მსმენელს
      userStateManager.removeListener(userChangeListener);

      // ვხსნით სქროლის მსმენელს
      window.removeEventListener("scroll", handleScroll);

      // ვაჩერებთ ტოკენის შემოწმების ინტერვალს
      userStateManager.stopTokenValidationCheck();
    };
  }, []);

  // ეფექტი, რომელიც იმუშავებს ყოველი ნავიგაციისას
  useEffect(() => {
    const checkAuth = async () => {
      const currentUser = userStateManager.getCurrentUser();

      // მხოლოდ იმ შემთხვევაში შევამოწმოთ, თუ მომხმარებელი უკვე შესულია
      // მხოლოდ JWT მომხმარებლებისთვის ვამოწმებთ ავთენტიფიკაციას
      if (currentUser && currentUser.user_type !== "clientOfGoogle") {
        await userStateManager.checkAuthStatus();
      }
    };

    checkAuth();
  }, [location.pathname]); // დამოკიდებულება location.pathname-ზე

  // ვაყენებთ არჩეულ ნავიგაციას URL-ის მიხედვით
  useEffect(() => {
    const path = location.pathname;
    if (path === "/") {
      setSelectedNavigation("home");
    } else if (path.includes("calculator")) {
      setSelectedNavigation("calculator");
    } else if (path.includes("search")) {
      setSelectedNavigation("search");
    } else if (path.includes("registration")) {
      setSelectedNavigation("registration");
    } else if (path.includes("authorization")) {
      setSelectedNavigation("authorization");
    }
  }, [location]);

  const handleNavigation = (nav: string) => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    setSelectedNavigation(nav);
    setMenuBar(false);
    setSearchByCity("");
    setSearchByDistrict("");
    setSearchByProfession("");
    setSearchByVerification("");
    setSearchByExperience("");
    setSearchByPriceFrom("");
    setSearchByPriceUpTo("");
    setTitleForCategory("");
  };

  const handleLogin = async () => {
    if (user?.user_type === "client") {
      navigate(`/client/personal-page/${user.external_Id}`);
    } else if (user?.user_type === "clientOfGoogle") {
      navigate(`/google-account`);
    } else {
      navigate(`/craftsman/personal-page/${user?.external_Id}`);
    }
    setMenuBar(false);
  };

  // მენიუს გადართვა ანიმაციით
  const toggleMenu = () => {
    setTimeout(() => {
      setMenuBar(!menuBar);
    }, 50);
  };

  // მენიუს ელემენტის კომპონენტი
  const MenuLink = ({
    to,
    iconComponent,
    text,
    isSelected,
    onClick,
  }: {
    to: string;
    iconComponent: React.ReactNode;
    text: string;
    isSelected: boolean;
    onClick: () => void;
  }) => (
    <Link
      to={to}
      className={`${styles.navElement} ${
        isSelected ? styles.selectedNavElement : ""
      }`}
      onClick={onClick}
    >
      {iconComponent}
      <span>{text}</span>
    </Link>
  );



  return (
    <>
      <div className={styles.parentContainer}>
        <div
          className={`${styles.navContainer} ${
            scrolled ? styles.scrolled : ""
          }`}
        >
          <nav className={styles.nav}>
            <div className={styles.logoContainer}>
              <Link
                to="/"
                onClick={() => {
                  handleNavigation("home");
                }}
              >
                <img src={logo} alt="logo" className={styles.logoImg} />
              </Link>

              <div className={styles.logoContainer__menuBarIcon}>
                {!menuBar ? (
                  <div>
                    <FontAwesomeIcon
                      icon={faBars}
                      className={styles.faBars}
                      onClick={toggleMenu}
                      aria-label="მენიუს გახსნა"
                      aria-expanded="false"
                    />
                  </div>
                ) : (
                  <FontAwesomeIcon
                    icon={faXmark}
                    className={styles.faXmark}
                    onClick={toggleMenu}
                    aria-label="მენიუს დახურვა"
                    aria-expanded="true"
                  />
                )}
              </div>
            </div>

            <div
              className={
                menuBar ? styles.mobileNavigation : styles.desktopNavigation
              }
              aria-expanded={menuBar}
              role="navigation"
            >
              <MenuLink
                to="/vipmanager"
                iconComponent={
                  <FontAwesomeIcon icon={faCrown} className={styles.faCrown} />
                }
                text="VIP პაკეტები"
                isSelected={selectedNavigation === "vipmanager"}
                onClick={() => handleNavigation("vipmanager")}
              />

              {/* გამოვიყენოთ ცალკე კომპონენტი მენიუს ელემენტებისთვის */}
              <MenuLink
                to="/calculator"
                iconComponent={
                  <FontAwesomeIcon
                    icon={faCalculator}
                    className={styles.faCalculator}
                  />
                }
                text="კალკულატორი"
                isSelected={selectedNavigation === "calculator"}
                onClick={() => handleNavigation("calculator")}
              />

              <MenuLink
                to="/search"
                iconComponent={
                  <FontAwesomeIcon
                    icon={faMagnifyingGlass}
                    className={styles.faMagnifyingGlass}
                  />
                }
                text="დეტალური ძებნა"
                isSelected={selectedNavigation === "search"}
                onClick={() => handleNavigation("search")}
              />

              <MenuLink
                to="/registration"
                iconComponent={
                  <FontAwesomeIcon
                    icon={faAddressCard}
                    className={styles.faAddressCard}
                  />
                }
                text="რეგისტრაცია"
                isSelected={selectedNavigation === "registration"}
                onClick={() => handleNavigation("registration")}
              />

              {isUserValid(user) ? (
                <div className={styles.isAuthorized} onClick={handleLogin}>
                  <img
                    src={user?.profile_img}
                    alt={user?.first_name}
                    className={styles.isAuthorized__userImg}
                  />
                  <p>{user?.first_name}</p>
                </div>
              ) : (
                <MenuLink
                  to="/authorization"
                  iconComponent={
                    <FontAwesomeIcon icon={faUser} className={styles.faUser} />
                  }
                  text="შესვლა"
                  isSelected={selectedNavigation === "authorization"}
                  onClick={() => handleNavigation("authorization")}
                />
              )}
            </div>
          </nav>
        </div>

        <Filter />
        <CookiesBanner />
        <PromotionalBanner />
        <div className={styles.outlet}>
          <div className={styles.outletInCenter}>
            <Outlet />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Root;
